<template>
  <div class="article" v-bind:class="{ active: selected === computed_items }" @click="select(computed_items)" @mouseover="hovered = true" @mouseleave="hovered = false">

    <div class="row  p-0 m-0 info-detail">
      <div class="col col-12  image_column  p-0">
        <img class="image left-image" draggable="false" :src="computed_items._source.ListPictureURL ? computed_items._source.ListPictureURL : require('@/assets/no_image.png')">
      </div>
      <div class="col col 12  info_column pt-2 pb-2">

        <div class="title is-5 mb-2">{{money(computed_items._source.ListPrice)}}<template v-if="computed_items._source.SystemDealType == 'RENT'">/mo</template>
        </div>

<!--          <div class="tag is-info is-light mb-1 info-detail-id">{{computed_items._id}}</div>-->
<!--          <span class="tag is-info">{{selected.type}}</span>-->
<!--          <span class="tag is-warning">{{ selected.size | prettyBytes }}</span>-->
<!--          <span class="tag" v-for="item in selected.tags" :key="item.key">{{item.term}}</span>-->



<!--        <div class="is-6 mb-1">{{computed_items._source.UnparsedAddress}}</div>-->
        <div class="is-6 mb-1 ">
          <span class="mr-1" v-if="computed_items._source.BedroomsTotal">{{computed_items._source.BedroomsTotal}} bds</span>
          <span class="mr-1" v-if="computed_items._source.SystemBathroomsCount">{{computed_items._source.SystemBathroomsCount}} ba</span>
          <span class="mr-1" v-if="computed_items._source.AreaTotal">{{computed_items._source.AreaTotal}} sqft</span>
          <span class="mobile">
            <span class="tag  mr-2">{{computed_items._source.SystemPropertyDescriptionType}}</span>
            <span class="tag ">{{computed_items._source.SystemDealTypeDescription}}</span>
          </span>
        </div>

        <div class="is-size-7 mb-1  address-box">
          <p><span class="is-capitalized">{{computed_items._source.FullStreetAddress && computed_items._source.FullStreetAddress.toLowerCase()}}</span>
          <span class="is-capitalized" >{{computed_items._source.City.toLowerCase()}}, </span>
            <span v-if="computed_items._source.StateOrProvince">{{computed_items._source.StateOrProvince.toUpperCase()}} </span>
            <span  v-if="computed_items._source.PostalCode" >{{computed_items._source.PostalCode.toLowerCase()}}</span></p>

        </div>

        <div class="desktop">
          <span class="tag  mr-2">{{computed_items._source.SystemPropertyDescriptionType}}</span>
          <span class="tag ">{{computed_items._source.SystemDealTypeDescription}}</span>
        </div>

<!--        <div class="subtitle is-6 is-flex is-align-items-center">-->
<!--          <b-icon-->
<!--            icon="cellphone"-->
<!--           >-->
<!--        </b-icon>-->
<!--          (732) 664-3255-->
<!--        </div>-->
<!--        <b-button type="is-primary  is-light" @click="contact(computed_items)">Contact property</b-button>-->
      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: 'listing_detail',
  components: {

  },
  props: {
    items:null,
    selected: null
  },
  data() {
    return {
      default_items: {},
      isLoading: false,
      error: false,
      hovered: false
    }
  },
  computed: {
    computed_items: function () {
      return this.items;
    }
  },
  methods: {
    TotalBaths(item) {
      const bathCount =  (item._source.MainLevelTotalBaths? parseInt(item._source.MainLevelTotalBaths) : 0)
          + (item._source.UpperLevel1FullBaths ? parseInt(item._source.UpperLevel1FullBaths) : 0)
          + (item._source.LowerLevel1FullBaths ? parseInt(item._source.LowerLevel1FullBaths) : 0);
      return bathCount;
    },
    select(item) {
      this.$emit('select', item);
    },
    highlight(item) {
      this.$emit('highlight', item);
    },
    contact(item) {
      this.$emit('contact', item);
    },
    money(val) {
      return parseInt(val).toLocaleString('en-US', { style: 'currency', currency: 'USD',  minimumFractionDigits: 0,
        maximumFractionDigits: 0 });
    }
  },
  mounted() {

  },
  watch: {
    hovered: function() {
      this.highlight(this.computed_items);
    }
  },
}
</script>

<style scoped>
.address-box{
  height: 2rem;
}
.image{
  border-top-left-radius: .35rem;
  border-top-right-radius: .35rem;

}
img.image.left-image {
  object-fit: cover;
  width: 100%;
  aspect-ratio: 6 / 3;
}
.article {
  box-shadow: 0 0.0625rem 0.1875rem #cacaca;
  background-color: #fff;
  margin-bottom: .9375rem;
  position: relative;
  opacity: 1;
  transition: opacity ease-out .3s;

  /*aspect-ratio: 10 / 5;*/
  /*width: 100%;*/
}
.article:hover {
  border-right: 2px solid blue;
}

.article.active {
  border-right: 3px solid blue;
}
.editor {
  max-width: 470px;
}
.mobile {
  display: none;
}
@media screen and (max-width: 600px) {
  img.image.left-image{
    aspect-ratio: 6 / 3;
  }
  .image_column {
    padding: 0;
  }
  .image{
    border-radius: 0;
  }
  .article{
    margin-bottom: 0.5rem;
  }
  .mobile {
    display: initial;
  }
  .desktop {
    display: none;
  }
}
</style>
<style >
.info-detail {
  position: relative;
}
.info-detail-id {
  position: absolute;
  top:1rem;
  left: 1rem;
}
</style>
